export default "__VITE_ASSET__Sk17DE4C__"